/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TYPE_META } from './typeMeta';

export const TypeBadge = ({ type }) => {
  const { t } = useTranslation();
  const meta = TYPE_META[type] || TYPE_META.initiative;
  const Icon = meta.icon;
  return (
    <span className="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-medium" style={{ backgroundColor: `${meta.color}20`, color: meta.color }} data-testid={`bacheca-type-badge-${type}`}>
      <Icon className="h-3 w-3" /> {t(type)}
    </span>
  );
};
